var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingBolt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 53,
    viewBox: "0 0 32 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8243 0.776825H11.4043C11.1859 0.776825 10.9894 0.910185 10.9089 1.11333L0.0381592 28.4912C-0.100854 28.8414 0.15712 29.2214 0.533866 29.2214H12.2569C12.599 29.2214 12.8526 29.539 12.7769 29.8726L7.85413 51.5694C7.72573 52.1352 8.4657 52.4702 8.80616 52.0003L31.1353 21.1786C31.3907 20.826 31.1387 20.3324 30.7033 20.3324H21.3782C20.9675 20.3324 20.711 19.8879 20.9163 19.5323L31.2862 1.57688C31.4915 1.22133 31.235 0.776825 30.8243 0.776825Z",
    fill: "#009F0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingBolt);
export default __webpack_public_path__ + "static/media/lightingBolt.b0b118b630cd4dc93766eba78fa7dc59.svg";
export { ForwardRef as ReactComponent };